<template>
	<div class="group" :class="type" @click="onSelect(order)">
		<div class="group-name">
			<IconCheckmark v-if="type === 'completed'" />
			<IconPause v-else-if="type === 'pause'" />
			<IconLock v-else-if="type === 'lock'" />
			<h5>{{ order }}. {{ name }}</h5>
		</div>
		<div class="group-topic">
			<span> {{ 'Topic' | translate }} {{ length }}</span>
			<IconChevron
				:fill="type === 'lock' ? '#BDBDBD' : '#000'"
				:orientation="orientation"
			/>
		</div>
	</div>
</template>
<script>
import IconCheckmark from '@/components/svg/IconCheckmark'
import IconChevron from '@/components/svg/IconChevron'
import IconLock from '@/components/svg/IconLock'
import IconPause from '@/components/svg/IconPause'

export default {
	name: 'GroupName',
	components: {
		IconPause,
		IconLock,
		IconCheckmark,
		IconChevron,
	},
	props: {
		onSelect: {
			type: Function,
		},
		orientation: {
			type: String,
		},
		order: {
			type: [Number, String],
		},
		name: {
			type: String,
		},
		length: {
			type: [Number, String],
		},
		type: {
			type: String,
		},
	},
}
</script>

<style lang="scss" scoped>
$color-orange: #ffc73b;
$color-gray-light: #f2f2f2;
$color-gray: #828282;
$color-gray-dark: #4f4f4f;
$color-pink: #fa0b76;
$color-yellow: #ffd210;
$color-green: #78d090;

.group {
	border-left: 4px solid transparent;
	background: #ffffff !important;
	color: #000000 !important;
	padding: 10px;
	margin-top: 10px;
	margin-bottom: 10px;
	display: flex;
	justify-content: space-between;
	position: relative;
	min-height: 66px;
	cursor: pointer;

	&-name {
		flex: 1;
		font-style: normal;
		font-weight: bold;
		font-size: 24px;
		line-height: 140%;
		display: flex;
		align-items: center;

		h5 {
			margin: 0;
			margin-left: 15px;
		}
	}

	&-topic {
		font-weight: normal;
		font-size: 16px;
		display: flex;
		align-items: center;
		line-height: 140%;
		@media (max-width: 768px) {
			flex-direction: column;
			align-items: center;
			justify-content: center;
			font-size: 12px;
		}

		span {
			margin-right: 10px;
		}
	}

	&-chevron {
		path {
			fill: #000;
		}
	}

	&.completed {
		border-left: 4px solid $color-green;
	}

	&.pause {
		border-left: 4px solid $color-yellow;
	}

	&.lock {
		border-left: 4px solid #bdbdbd;
		color: #bdbdbd;
		cursor: not-allowed;

		.group-name {
			color: #bdbdbd;
		}

		.group-topic {
			color: #bdbdbd;
		}
	}
}
</style>
